import { useCallback } from 'react'
import useScript from 'react-script-hook'

import { useFlags } from 'launchdarkly-react-client-sdk'

import { useIsIntlRestaurant } from 'src/lib/js/hooks/useIsIntlRestaurant'
import { useTracker } from 'src/lib/js/hooks/useTracker'

import { resources } from 'config'

declare global {
  interface Window {
    Toast: any
  }
}

export const useSpi = () => {
  const { ooSpiSurchargingFe } = useFlags()
  const isIntlRestaurant = useIsIntlRestaurant()

  return { spiSurchargingEnabled: !isIntlRestaurant && ooSpiSurchargingFe }
}

// When enabled, the server confirms the SPI payment as part of placing the order,
// so the client skips spiUpdatePaymentIntent and spiSdk.confirmPayment.
export const useServerSpi = () => {
  const { ooServerSpi } = useFlags()
  const isIntlRestaurant = useIsIntlRestaurant()

  return { serverSpiEnabled: !isIntlRestaurant && ooServerSpi }
}

// Only log SPI events if the FF is enabled
export const useSpiEventTracker = () => {
  const { ooSpiTempEventsEnabled } = useFlags()
  const tracker = useTracker()

  const track = useCallback(
    (name: any, data: any) => {
      if (ooSpiTempEventsEnabled) {
        tracker.track(name, data)
      }
    },
    [tracker, ooSpiTempEventsEnabled]
  )

  return { trackSpi: track }
}

export const useSpiSdk = (skip?: boolean) => {
  const isIntlRestaurant = useIsIntlRestaurant()
  const { trackSpi } = useSpiEventTracker()
  const [loading, error] = useScript({
    src: !skip && !isIntlRestaurant ? resources.spiURL : null
  })

  if (error) {
    trackSpi('temp_SPI_sdk_failed', {})
  }
  return !loading && !error && typeof window !== 'undefined'
    ? window.Toast
    : undefined
}
